import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

type AuthData = {
    isAuth: boolean;
    currentUserId: number;
    currentUserEmail: string;
    currentUserRole: string;
    isAdministrator: boolean;
}

export const useAuth = (): AuthData => {
    const authToken = Cookies.get('authToken') as string;
    const adminRoles = ['Administrator', 'SuperAdministrator'];
    if (!authToken) return (
        {
            isAuth: false,
            currentUserId: 0,
            currentUserEmail: '',
            currentUserRole: '',
            isAdministrator: false,
        });
    const decodedToken = jwtDecode(authToken) as any;
    const expirationDate = decodedToken?.exp ? decodedToken.exp * 1000 : null;

    if (!authToken || !expirationDate) {
        return ({
            isAuth: false,
            currentUserId: 0,
            currentUserEmail: '',
            currentUserRole: '',
            isAdministrator: false,
        });
    }

    const isExpired = new Date(expirationDate) < new Date();
    return ({
        isAuth: !isExpired,
        currentUserId: +decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
        currentUserEmail: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
        currentUserRole: decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
        isAdministrator: adminRoles.some((item) => item === decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']),
    })
};